import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { ClientManagerInstanceToken, ClientManagerInterface } from '../../interfaces/client-manager.interface';
import { UriUtilitiesService } from '../uri-utilities/uri-utilities.service';
import { UserGidService } from '../user-gid/user-gid.service';
import { SessionId } from '../session/session.type';
import { OdataAppVersionPayload } from './odata-appversion-payload.interface';
import { UserMasterService } from '../user-master/user-master.service';

@Injectable({
    providedIn: 'root',
})
export class AppVersionAndSessionService {
    public constructor(
        private readonly http: HttpClient,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
        private readonly userGidService: UserGidService,
        private readonly uriUtilities: UriUtilitiesService,
        private readonly userMasterService: UserMasterService,
    ) {}

    public sendAppVersionAndSessionId(sessionId: SessionId): Observable<void> {
        const payload: OdataAppVersionPayload = {
            app_version: this.clientManager.getAppVersion(),
            app_name: this.userMasterService.getSharpServiceText(),
            front_id: this.userGidService.getUserGid(),
            session_id: sessionId,
        };
        return this.http
            .post(this.uriUtilities.getUriForContent() + ENDPOINTS.AppVersionSet, payload)
            .pipe(map(() => undefined));
    }
}
